import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import IconS3 from '@white-label-icon/icons-s3';


const __default__ = {
  name: 'IconButton',
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  iconName: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const kebabIconName = computed(() =>
  props.iconName
    .replace(/([A-Z])/g, '-$1')
    .toLowerCase()
    .replace(/^-/, '')
);

return { __sfc: true,props, kebabIconName, IconS3 }
}

})